// This file was auto generated (scripts/generate-i18n-date.js)
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);

interface I18nResource {
    name: string;
}

interface LoadedLocales {
    [locale: string]: I18nResource;
}

const loadedLocales: LoadedLocales = {};

async function loadI18n(locale: string): Promise<I18nResource> {
    if (loadedLocales[locale] !== undefined) {
        dayjs.locale(locale);
        return Promise.resolve(loadedLocales[locale]);
    }
    switch (locale.toLowerCase()) {
        case "af":
            return await import("dayjs/locale/af.js");
        case "am":
            return await import("dayjs/locale/am.js");
        case "ar":
            return await import("dayjs/locale/ar.js");
        case "az":
            return await import("dayjs/locale/az.js");
        case "be":
            return await import("dayjs/locale/be.js");
        case "bg":
            return await import("dayjs/locale/bg.js");
        case "bi":
            return await import("dayjs/locale/bi.js");
        case "bm":
            return await import("dayjs/locale/bm.js");
        case "bn":
            return await import("dayjs/locale/bn.js");
        case "bo":
            return await import("dayjs/locale/bo.js");
        case "br":
            return await import("dayjs/locale/br.js");
        case "bs":
            return await import("dayjs/locale/bs.js");
        case "ca":
            return await import("dayjs/locale/ca.js");
        case "cs":
            return await import("dayjs/locale/cs.js");
        case "cv":
            return await import("dayjs/locale/cv.js");
        case "cy":
            return await import("dayjs/locale/cy.js");
        case "da":
            return await import("dayjs/locale/da.js");
        case "de":
            return await import("dayjs/locale/de.js");
        case "dv":
            return await import("dayjs/locale/dv.js");
        case "el":
            return await import("dayjs/locale/el.js");
        case "en":
            return await import("dayjs/locale/en.js");
        case "eo":
            return await import("dayjs/locale/eo.js");
        case "es":
            return await import("dayjs/locale/es.js");
        case "et":
            return await import("dayjs/locale/et.js");
        case "eu":
            return await import("dayjs/locale/eu.js");
        case "fa":
            return await import("dayjs/locale/fa.js");
        case "fi":
            return await import("dayjs/locale/fi.js");
        case "fo":
            return await import("dayjs/locale/fo.js");
        case "fr":
            return await import("dayjs/locale/fr.js");
        case "fy":
            return await import("dayjs/locale/fy.js");
        case "ga":
            return await import("dayjs/locale/ga.js");
        case "gd":
            return await import("dayjs/locale/gd.js");
        case "gl":
            return await import("dayjs/locale/gl.js");
        case "gu":
            return await import("dayjs/locale/gu.js");
        case "he":
            return await import("dayjs/locale/he.js");
        case "hi":
            return await import("dayjs/locale/hi.js");
        case "hr":
            return await import("dayjs/locale/hr.js");
        case "ht":
            return await import("dayjs/locale/ht.js");
        case "hu":
            return await import("dayjs/locale/hu.js");
        case "id":
            return await import("dayjs/locale/id.js");
        case "is":
            return await import("dayjs/locale/is.js");
        case "it":
            return await import("dayjs/locale/it.js");
        case "ja":
            return await import("dayjs/locale/ja.js");
        case "jv":
            return await import("dayjs/locale/jv.js");
        case "ka":
            return await import("dayjs/locale/ka.js");
        case "kk":
            return await import("dayjs/locale/kk.js");
        case "km":
            return await import("dayjs/locale/km.js");
        case "kn":
            return await import("dayjs/locale/kn.js");
        case "ko":
            return await import("dayjs/locale/ko.js");
        case "ku":
            return await import("dayjs/locale/ku.js");
        case "ky":
            return await import("dayjs/locale/ky.js");
        case "lb":
            return await import("dayjs/locale/lb.js");
        case "lo":
            return await import("dayjs/locale/lo.js");
        case "lt":
            return await import("dayjs/locale/lt.js");
        case "lv":
            return await import("dayjs/locale/lv.js");
        case "me":
            return await import("dayjs/locale/me.js");
        case "mi":
            return await import("dayjs/locale/mi.js");
        case "mk":
            return await import("dayjs/locale/mk.js");
        case "ml":
            return await import("dayjs/locale/ml.js");
        case "mn":
            return await import("dayjs/locale/mn.js");
        case "mr":
            return await import("dayjs/locale/mr.js");
        case "ms":
            return await import("dayjs/locale/ms.js");
        case "mt":
            return await import("dayjs/locale/mt.js");
        case "my":
            return await import("dayjs/locale/my.js");
        case "nb":
            return await import("dayjs/locale/nb.js");
        case "ne":
            return await import("dayjs/locale/ne.js");
        case "nl":
            return await import("dayjs/locale/nl.js");
        case "nn":
            return await import("dayjs/locale/nn.js");
        case "pl":
            return await import("dayjs/locale/pl.js");
        case "pt":
            return await import("dayjs/locale/pt.js");
        case "rn":
            return await import("dayjs/locale/rn.js");
        case "ro":
            return await import("dayjs/locale/ro.js");
        case "ru":
            return await import("dayjs/locale/ru.js");
        case "rw":
            return await import("dayjs/locale/rw.js");
        case "sd":
            return await import("dayjs/locale/sd.js");
        case "se":
            return await import("dayjs/locale/se.js");
        case "si":
            return await import("dayjs/locale/si.js");
        case "sk":
            return await import("dayjs/locale/sk.js");
        case "sl":
            return await import("dayjs/locale/sl.js");
        case "sq":
            return await import("dayjs/locale/sq.js");
        case "sr":
            return await import("dayjs/locale/sr.js");
        case "ss":
            return await import("dayjs/locale/ss.js");
        case "sv":
            return await import("dayjs/locale/sv.js");
        case "sw":
            return await import("dayjs/locale/sw.js");
        case "ta":
            return await import("dayjs/locale/ta.js");
        case "te":
            return await import("dayjs/locale/te.js");
        case "tg":
            return await import("dayjs/locale/tg.js");
        case "th":
            return await import("dayjs/locale/th.js");
        case "tk":
            return await import("dayjs/locale/tk.js");
        case "tr":
            return await import("dayjs/locale/tr.js");
        case "uk":
            return await import("dayjs/locale/uk.js");
        case "ur":
            return await import("dayjs/locale/ur.js");
        case "uz":
            return await import("dayjs/locale/uz.js");
        case "vi":
            return await import("dayjs/locale/vi.js");
        case "yo":
            return await import("dayjs/locale/yo.js");
        case "zh":
            return await import("dayjs/locale/zh.js");
        default:
            return await import("dayjs/locale/en.js");
    }
}

export async function initI18nDate(locale: string): Promise<void> {
    return loadI18n(locale).then((i18n) => {
        if (i18n !== undefined && i18n.name.valueOf() === locale) {
            loadedLocales[locale] = i18n;
            dayjs.locale(locale);
        }
    });
}

export default initI18nDate;
